/**
 * 严肃声明：
 * 开源版本请务必保留此注释头信息，若删除我方将保留所有法律责任追究！
 * 本系统已申请软件著作权，受国家版权局知识产权以及国家计算机软件著作权保护！
 * 可正常分享和学习源码，不得用于违法犯罪活动，违者必究！
 * Copyright (c) 2020 陈尼克 all rights reserved.
 * 版权所有，侵权必究！
 */

import axios from '../utils/axios'

// 去支付
export function createOrderPay(params) {
  return axios.post('/order/order/create', params);
}
export function orderPayNow(params) {
  return axios.get('/member/order/view', {params});
}

// 订单列表
export function orderList(params) {
  return axios.get('/member/order/index', {params});
}

// 取消订单
export function closeOrder(params) {
  return axios.get('/member/order/close', {params});
}

//订单详情
export function orderDetails(params) {
  return axios.get('/member/order/view2', {params});
}

export function createOrder(params) {
  return axios.post('/saveOrder', params);
}

export function getOrderList(params) {
  return axios.get('/order', { params });
}

export function getOrderDetail(id) {
  return axios.get(`/order/${id}`);
}

export function cancelOrder(id) {
  return axios.put(`/order/${id}/cancel`);
}

export function confirmOrder(id) {
  return axios.put(`/order/${id}/finish`)
}

export function payOrder(params) {
  return axios.get('/paySuccess', { params })
}




